module.exports = __webpack_public_path__ + "static/img/logo@2x.761639e.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/bottom/logo@2x.png
// module id = nmIM
// module chunks = 1